import React from 'react'
import ProfileMenu from './ProfileMenu'
import styles from './style.module.scss'

class TopBar extends React.Component {
  render() {
    return (
      <div className={styles.topbar}>
        <div className="mr-4">{/* <IssuesHistory /> */}</div>
        <div className="mr-4">{/* <ProjectManagement /> */}</div>
        <div className="mr-auto">{/* <LiveSearch /> */}</div>
        <div className="mr-4">{/* <BitcoinPrice /> */}</div>
        <div className="mr-4">{/* <LanguageSelector /> */}</div>
        {/* <div className="mr-4">
          <HomeMenu />
        </div> */}
        <ProfileMenu />
      </div>
    )
  }
}

export default TopBar
